import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { SubmittedFormPreviewService } from './submitted-form-preview.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HazardFormListFilterComponent } from '../hazard-form-filter/hazard-form-filter.component';
import * as _ from 'lodash';
import { SubFormComponent } from '../rFF/sub-form/sub-form.component';
import { FormService } from '../rFF/form/form.service';
declare var $: any;

@Component({
    selector: 'app-submitted-form-preview',
    templateUrl: './submitted-form-preview.component.html',
    styleUrls: ['./submitted-form-preview.component.scss']
})
export class SubmittedFormPreviewComponent implements OnInit {

    @ViewChild('disp') iframe: ElementRef;

    submittedForm: any = [{}];
    errMessage: String;
    passwordValue: string = '';
    displayPwd: Boolean;
    downloadType: String;
    formType: String = '';
    taskId: String = '';
    constructor(
        public _activatedRoute: ActivatedRoute,
        private _submittedFormPreviewService: SubmittedFormPreviewService,
        private _capabilityEngineService: CapabilityEngineService,
        private _router: Router,
        private modalService: NgbModal,
        private _formService: FormService
    ) { 
        this.taskId = this._activatedRoute.snapshot.params['id'];
    }

    ngOnInit() {
        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            this._submittedFormPreviewService.getSubmittedFormPreviewHtml(this.taskId)
                .subscribe((result: any) => {
                    console.log("​SubmittedFormPreviewComponent -> ngOnInit -> result", result)
                    if(result && result.data && result.data.dbTask && result.data.dbTask.template && result.data.dbTask.template.category) {
                        this.formType = result.data.dbTask.template.category
                    }
                    this.submittedForm = result.data.dbTask;
                    let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
                    doc.open();
                    doc.write(result.data.html);
                    doc.close();
                }, (err) => {
                    console.log('​SubmittedFormPreviewComponent -> ngOnInit -> ', err);
                });
        }
    }

    reload(taskId) {
        const pathData = this._activatedRoute.data['_value'];
        this.taskId = taskId;
        if (this.canPerform(pathData.capabilities)) {
            this._submittedFormPreviewService.getSubmittedFormPreviewHtml(taskId)
                .subscribe((result: any) => {
                    console.log("​SubmittedFormPreviewComponent -> reload -> result", result);
                    if(result && result.data && result.data.dbTask && result.data.dbTask.template && result.data.dbTask.template.category) {
                        this.formType = result.data.dbTask.template.category
                    }
                    this.submittedForm = result.data.dbTask;
                    let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
                    doc.open();
                    doc.write(result.data.html);
                    doc.close();
                }, (err) => {
                    console.log('​SubmittedFormPreviewComponent -> reload -> ', err);
                });
        }
    }

    downloadPdf() {
        // let dataObj = {
        //     ids: [this._activatedRoute.snapshot.params['id']],
        //     downloadType: this.downloadType
        // };
        let dataObj = {
            _id: this.submittedForm._id,
            taskId: this.submittedForm.taskId,
            downloadType: this.downloadType,
            workOrderId: this.submittedForm.workOrderId,
            inspectionId: this.submittedForm.inspectionID,
        };
        if (this.isTake5Form()) {
            return this._submittedFormPreviewService.downloadTake5Pdf([dataObj])
                .subscribe((data: any) => {
                    let folderName = '';
                    folderName = (environment.APP_NAME || '') + ' PDF ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                    const blob = new Blob([data], { type: 'application/pdf;charset=utf-8' });
                    saveAs(blob, `Take 5 PDF ` + dataObj.taskId + `.pdf`);
                });
        }
        this._submittedFormPreviewService.downloadMultiplePdf([dataObj])
            .subscribe((data: any) => {
                let folderName = '';
                folderName = (environment.APP_NAME || '') + ' PDF ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                const blob = new Blob([data], { type: 'application/zip;charset=utf-8' });
                saveAs(blob, `${folderName}.zip`);
            });
    }
    downloadmultiplecsv() {
        // console.log(csvIds, 'ids for csv');
        let dataObj = {
            ids: [this.submittedForm._id],
            downloadType: 'CSV'
        };

        const templateId = this.submittedForm.template._id;
        if (templateId === '5da944a49e6002772ba9bbcc' || templateId === 'fh_template_preview:workplaceinspection') {
            this._submittedFormPreviewService
                .downloadLHoistCSV(dataObj)
                .subscribe((data: any) => {
                    let folderName = '';
                    folderName = (environment.APP_NAME || '') + ' CSV ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                    const blob = new Blob([data], {
                        type: 'application/xlsx'//'application/zip;charset=utf-8'
                    });
                    saveAs(blob, `${folderName}.xlsx`);
                });
            return;
        }

        this._submittedFormPreviewService
            .downloadMultipleCSV(dataObj)
            .subscribe((data: any) => {
                let folderName = '';
                folderName = (environment.APP_NAME || '') + ' CSV ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                const blob = new Blob([data], {
                    type: 'application/zip;charset=utf-8'
                });
                saveAs(blob, `${folderName}.zip`);
            });
    }

    toggleModal(_downloadType: String) {
        this.downloadType = _downloadType;
    }

    reviewForm(reviewData?) {
        let task = {
            id: this.submittedForm._id
        };
        if(reviewData) {
            task['reviewData'] = reviewData
        }
        console.log('​SubmittedFormPreviewComponent -> reviewForm -> task', task);
        this._submittedFormPreviewService.reviewForm(task)
            .subscribe((result: any) => {
                // console.log("hello world make it as reviewd")
                console.log('​SubmittedFormPreviewComponent -> ngOnInit -> this.submittedForm', result);
                // this._router.navigateByUrl('/submittedForms');
                this.submittedForm.status = 2;
                this.ngOnInit()
            }, (err) => {
                console.log('​SubmittedFormPreviewComponent -> ngOnInit -> ', err);
            });
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    hazardfilter() {
        let modalOptions: any = {
            size: 'md',
            centered: true,
            windowClass: 'hazard-filter',
        };
        const modalRef = this.modalService.open(
            HazardFormListFilterComponent,
            modalOptions
        );
        modalRef.componentInstance.parentComponentData = {
            filter: 'voltas',
            templateId: this._activatedRoute.snapshot.params['id']
        }
        modalRef.result.then(
            res => {
                console.log('confirmed for changes', this._activatedRoute.snapshot.params);
            },
            () => {
                console.log('not confirmed for changes', this._activatedRoute.snapshot.params);

            }
        );
    }

    deleteForm() {
        let task = {
            id: this.submittedForm._id
        };
        console.log('delete form');
        this._submittedFormPreviewService.deleteForm(task)
            .subscribe((result: any) => {
                console.log('​SubmittedFormPreviewComponent -> ngOnInit -> this.submittedForm', result);
                // this._router.navigateByUrl('/');
                window.history.back();
                this.submittedForm.isDeleted = true;
            }, (err) => {
                console.log('​SubmittedFormPreviewComponent -> ngOnInit -> ', err);
            });
    }

    isFioreShiftForm() {
        if (this.submittedForm && this.submittedForm.template && this.submittedForm.template["_id"] === environment.NISS_TEMPLATE_ID) {
            return true;
        }
        return false;
    }

    isAesaForm() {
        if (this.submittedForm && this.submittedForm.template && this.submittedForm.template["_id"] === environment.AESA_TEMPLATE_ID) {
            return true;
        }
        return false;
    }

    isTake5Form() {
        if (this.submittedForm && this.submittedForm.template && this.submittedForm.template["_id"] === environment.TAKE_5_TEMPLATE_ID) {
            return true;
        }
        return false;
    }

    downloadFioreExcel() {
        let request = {
            tasks: [this.submittedForm]
        };
        this._submittedFormPreviewService.downloadFioreExcel(request).subscribe((response) => {
            saveAs(response, `${this.submittedForm._id}.zip`);
        }, (error) => {
            console.log(error);
        });
    }

    downloadAesaExcel() {
        let request = {
            task: [this.submittedForm._id]
        };
        this._submittedFormPreviewService.downloadAesaExcel(request).subscribe((response) => {
            saveAs(response, `${this.submittedForm._id}.zip`);
        }, (error) => {
            console.log(error);
        });
    }

    openReviewForm() {
        this._submittedFormPreviewService.getReviewFormTemplate().subscribe((result) => {
            if(result['success']) {
                if(result['data'] && result['data'].length > 0) {
                    let modalOptions: any = {
                        size: 'md',
                        centered: true,
                        windowClass: 'md-dialog-large',
                    };
                    const modalRef = this.modalService.open(
                        SubFormComponent,
                        modalOptions
                    );

                    modalRef.componentInstance.template = result['data'][0]
                    modalRef.componentInstance.subFormPreview = true;
            
                    modalRef.result.then((data) => {
                        data['templateId'] = result['data'][0]["_id"]
                        this.submittedForm['reviewData'] = data;
                        delete data['template']
                        this.reviewForm(data)
                    }).catch((e) => {
                        console.log("error",e)
                    });
                } else {
                    this.reviewForm()
                }
            } 
        })
    }

    openReviewFormData(submittedForm) {
        if(submittedForm && submittedForm['reviewData']) {
            this._formService.getForm(submittedForm['reviewData']['templateId']).subscribe((result) => {
                if(result['data']['templateDetails']) {
                    let modalOptions: any = {
                        size: 'md',
                        centered: true,
                        windowClass: 'md-dialog-large',
                    };
                    const modalRef = this.modalService.open(
                        SubFormComponent,
                        modalOptions
                    );
                    modalRef.componentInstance.data = submittedForm['reviewData']['data'];
                    modalRef.componentInstance.subFormPreview = true;
                    modalRef.componentInstance.template = result['data']['templateDetails'];
                }
            })

        }
    }
    navigateToBack() {
        localStorage.removeItem('submittedFormIds');
        window.history.back();
    }

    navigateToResolveIncident () {
      this._router.navigateByUrl('/formFilling/fh_task_template:resolveform?currentPage=incidentForms&incident=' + this.submittedForm._id);
    }

    toPrevious() {
        let formListData = localStorage.getItem('submittedFormIds') ? JSON.parse(localStorage.getItem('submittedFormIds')) : {};
        let formIds = formListData[this.submittedForm.template._id];
        if (formIds && formIds.length > 0) {
            let index = formIds.indexOf(this.submittedForm._id);
            if (index-1 >= 0 && formIds[index-1]) {
                this.reload(formIds[index-1])
            } else {

            }
        }
    }
    toNext() {
        let formListData = localStorage.getItem('submittedFormIds') ? JSON.parse(localStorage.getItem('submittedFormIds')) : {};
        let formIds = formListData[this.submittedForm.template._id];
        if (formIds && formIds.length > 0) {
            let index = formIds.indexOf(this.submittedForm._id);
            if (index+1 >= 0 && formIds[index+1]) {
                this.reload(formIds[index+1])
            } else {

            }
        }
    }

    getFormType(type) {

        if (type === this.formType) {
            return true;
        }
        return false;
    }

    isIncidentFormType(): boolean {
        return this._activatedRoute.snapshot.queryParams.formType === 'incident';
    }
}



// WEBPACK FOOTER //
// ./src/app/submitted-form-preview/submitted-form-preview.component.ts